import React from "react"
import styled from "styled-components"
import { Flex, StyledLink } from "../../styles/base-styles"
import { WpPost } from "../../types/wordpress-types"
import { getCategorySettings, TEXTS } from "../../utils/constants"
import { PostsSectionHeader } from "./posts-section-header"
import { PostLinks } from "./post-links"

interface Props {
  posts: WpPost[]
}

export const RelatedPosts: React.FC<Props> = ({ posts }) => {
  return (
    <RelatedPostsFlex isColumn>
      <PostsSectionHeader title={"関連する記事"} />
      <PostLinks posts={posts} />
    </RelatedPostsFlex>
  )
}

const RelatedPostsFlex = styled(Flex)``
